import React from "react"
import { Container, Box, Backdrop } from "@mui/material"

import { makeStyles } from "makeStyles"

import Link from "components/i18n/Link"
import Button from "components/Buttons/Button"
import Price from "components/Price"
import UpSellProducts from "./UpSellProducts"
import LazyLoadedImage from "components/LazyLoadedImage"

import getImageWithSizeSuffixes from "@secureo/common/utils/commerceTools/formatters/getImageWithSizeSuffixes"
import mergeConfiguredLineItems from "@secureo/common/utils/commerceTools/mergeConfiguredLineItems"

import { DispatchProductDetailPageReducer } from "@secureo/common/reducers/productDetailPageReducer"
import { Cart } from "@secureo/common/typings/Cart"
import { CountryCode } from "@secureo/common/typings/CountryCode"

const useStyles = makeStyles()({
	fakeDrawer: {
		width: "27%",
		position: "absolute",
		right: 0,
		top: 0,
		flexShrink: 0,
		height: "100%",
		background: "#4691CE",
		color: "white",
		boxShadow: "-20px 0px 20px 0px rgba(0,0,0,0.15)",
		"@media only screen and (min-width: 1200px) and (max-width: 1400px)": {
			width: "40%",
		},
		"@media only screen and (min-width: 1060px) and (max-width: 1200px)": {
			width: "35%",
		},
		"@media only screen and (max-width: 1060px)": {
			width: "100%",
		},
	},
	backdrop: {
		zIndex: 1100,
	},
})

const IntermediateCart = ({
	dispatch,
	masterVariantSku,
	countryCode,
	cart,
	upSellProductSkus = [],
}: Props) => {
	const { classes } = useStyles()

	if (!cart) return null

	const {
		lineItems,
		taxedPrice: {
			totalGross: { centAmount: totalGrossCents },
		},
	} = cart
	const mergedConfiguredLineItems = mergeConfiguredLineItems(lineItems)

	const onClose = () => {
		dispatch({ type: "TOGGLE_INTERMEDIATE_SHOPPING_CART" })
	}

	return (
		<>
			<Backdrop className={classes.backdrop} open>
				{upSellProductSkus.length > 0 && (
					<UpSellProducts
						upSellProductSkus={upSellProductSkus}
						countryCode={countryCode}
						masterVariantSku={masterVariantSku}
						onClose={onClose}
					/>
				)}
				{/* Right Drawer, Cart Items */}
				<div className={classes.fakeDrawer}>
					<Box mt={3} ml={2} mb={2} style={{ fontSize: 22 }}>
						Warenkorb
					</Box>
					<Box
						px={2}
						mt={3}
						style={{
							height: "65vh",
							maxHeight: "65vh",
							overflowY: "scroll",
							paddingBottom: 50,
						}}
					>
						{mergedConfiguredLineItems.map((lineItem) => {
							const {
								taxedPrice: {
									totalGross: { centAmount: totalGrossCents },
								},
								variant: { images = [] },
								quantity,
							} = lineItem

							const name = lineItem.variant?.variantName || lineItem.name
							const image = images[0]
								? getImageWithSizeSuffixes(images[0]).medium
								: "https://via.placeholder.com/100x100"

							return (
								<Box
									mb={3}
									p={1}
									key={name}
									style={{
										display: "flex",
										alignItems: "flex-start",
										justifyContent: "space-between",
										background: "white",
										borderRadius: 9,
										boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.25)",
									}}
								>
									<Box
										mr={1}
										p={1}
										style={{
											background: "#EDEFF0",
											borderRadius: 8,
											maxWidth: 70,
											maxHeight: 70,
										}}
									>
										<LazyLoadedImage
											alt={name}
											title={name}
											src={image}
											style={{
												height: 70,
												width: 70,

												objectFit: "contain",
												mixBlendMode: "multiply",
											}}
										/>
									</Box>
									<Box
										mt={1}
										style={{
											color: "#505e5f",
											textAlign: "left",
											width: "100%",
										}}
									>
										{quantity}x {name}
									</Box>
									<Box
										mt={1}
										pl={1}
										style={{ textAlign: "left", color: "black" }}
									>
										<strong>
											<Price priceInEuroCents={totalGrossCents} />
										</strong>
									</Box>
								</Box>
							)
						})}
					</Box>
					<Box
						pt={1}
						pb={5}
						style={{
							position: "absolute",
							bottom: 0,
							width: "100%",
						}}
					>
						<Container>
							<Box
								pr={1}
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>
									<strong>Gesamtbetrag</strong>{" "}
									<span style={{ color: "#B8BCBF" }}>(inkl. MwSt.)</span>
								</div>
								<div style={{ textAlign: "right" }}>
									<strong>
										<Price priceInEuroCents={totalGrossCents} />
									</strong>
								</div>
							</Box>
							<Box mt={2} style={{ display: "flex", alignItems: "center" }}>
								<Box mr={1} style={{ width: "50%" }}>
									<Button color="link-no-underline" onClick={onClose}>
										<span style={{ color: "white" }}>Weiter einkaufen</span>
									</Button>
								</Box>

								<div style={{ width: "50%" }}>
									<Link href="/cart">
										<Button>Zum Warenkorb</Button>
									</Link>
								</div>
							</Box>
						</Container>
					</Box>
				</div>
			</Backdrop>
		</>
	)
}

interface Props {
	dispatch: DispatchProductDetailPageReducer
	cart: Cart
	countryCode: CountryCode
	upSellProductSkus: string[]
	masterVariantSku: string
}

export default IntermediateCart
